import { Component, OnInit } from '@angular/core';
import { faRoute } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-public',
  templateUrl: './public.page.html',
  styleUrls: ['./public.page.scss'],
})
export class PublicPage implements OnInit {
  faroute = faRoute;
  constructor() { }

  ngOnInit() {
  }

}
